import { FormattedMessage } from 'react-intl';
import { Heading, SimpleGrid } from '@chakra-ui/react';

import ComboboxFormikField from '../forms/ComboboxFormikField';

const LoadDefinitionPanel = ({ idx, definitions, formLabels }) => {
    const definition = definitions.loadDefinitionResponses[idx];

    return (
        <>
            <Heading as="h4" variant="h4">
                <FormattedMessage id="load_definitions_heading" />
            </Heading>

            <SimpleGrid columns={{ xl: 3 }} spacingX={6}>
                <ComboboxFormikField
                    mt={3}
                    id={'moduleProcessId' + idx}
                    name={`definitions.${definition.id}.moduleProcessId`}
                    label={formLabels.modelType}
                    options={definitions.modelTypes}
                    labelKey="labelName"
                    valueKey="id"
                    placeholderValue=""
                    placeholderLabel={formLabels.selectPlaceholder}
                    isFastField
                />

                <ComboboxFormikField
                    mt={3}
                    id={'weatherZoneId' + idx}
                    name={`definitions.${definition.id}.weatherZoneId`}
                    label={formLabels.weatherZone}
                    options={definitions.weatherZones}
                    valueKey="id"
                    labelKey="name"
                    placeholderValue=""
                    placeholderLabel={formLabels.selectPlaceholder}
                    isFastField
                />

                <ComboboxFormikField
                    mt={3}
                    id={'modelWeightId' + idx}
                    name={`definitions.${definition.id}.modelWeightId`}
                    label={formLabels.dataWeight}
                    options={definitions.dataWeightings}
                    valueKey="id"
                    labelKey="description"
                    placeholderValue=""
                    placeholderLabel={formLabels.selectPlaceholder}
                    isFastField
                />

                <ComboboxFormikField
                    mt={3}
                    id={'retailPriceItemId' + idx}
                    name={`definitions.${definition.id}.retailPriceItemId`}
                    label={formLabels.retailPriceItem}
                    options={definitions.retails}
                    valueKey="id"
                    labelKey="description"
                    placeholderValue=""
                    placeholderLabel={formLabels.selectPlaceholder}
                    isFastField
                />

                <ComboboxFormikField
                    mt={3}
                    id={'nativeLoad' + idx}
                    name={`definitions.${definition.id}.nativeLoad`}
                    label={formLabels.native}
                    options={definitions.nativeOptions}
                    valueKey="id"
                    labelKey="description"
                    isFastField
                />
            </SimpleGrid>
        </>
    );
};

export default LoadDefinitionPanel;
